import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { parseServicesSuffixUrl, toCanonicalServicesUrl } from './services-route.util';

/**
 * Redirects suffix-form services URLs (/services/irrigation/:plantationId)
 * to the canonical prefix form (/services/:plantationId/irrigation).
 */
export const servicesUrlNormalizeGuard: CanActivateFn = (_route, state) => {
  const parsed = parseServicesSuffixUrl(state.url);
  if (!parsed) {
    return true;
  }

  return inject(Router).parseUrl(toCanonicalServicesUrl(parsed.plantationId, parsed.tab, parsed.query));
};
